import { TFileTypes } from '@interfaces/import/import';

import { EFileExtensions, EMIMETypes } from '@enums/common';
import { EDropzoneFileErrorCodes } from '@enums/dropzone';

export const acceptedFileTypes: TFileTypes = {
	[EMIMETypes.png]: [EFileExtensions.png],
	[EMIMETypes.doc]: [EFileExtensions.doc],
	[EMIMETypes.docx]: [EFileExtensions.docx],
	[EMIMETypes.xls]: [EFileExtensions.xls],
	[EMIMETypes.xlsx]: [EFileExtensions.xlsx],
	[EMIMETypes.jpeg]: [EFileExtensions.jpeg, EFileExtensions.jpg],
	[EMIMETypes.pdf]: [EFileExtensions.pdf],
};

const MAX_MEGA_BYTES = 20;

export const MAX_BYTES = MAX_MEGA_BYTES * 1024 * 1024;

export const fileErrors = {
	[EDropzoneFileErrorCodes.fileInvalidType]: 'Extension is not supported. Supports: DOC, DOCX, XLS, XLSX, JPG, PNG, PDF',
	[EDropzoneFileErrorCodes.fileTooLarge]: `
		File size is too large. File size must be less than or equal to ${MAX_MEGA_BYTES}MB.`,
};

export const supportsText = 'Supports: DOC, DOCX, XLS, XLSX, JPG, PNG, PDF';
